import {globals} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {copyToClipboard, resetCommunityGraphicsGraphic} from "./graphics.js";
import {
	escapeHTML,
	getShortenedName,
	hideMainMenuContent, makeGetRequest,
	previewSegmentSinglesParticipants,
	previewSegmentTagParticipants
} from "./ui-helpers.js";
import {getRandomChoice, shuffle, toTitleCase} from "../modules/helpers.js";
import {customSegmentsData, parseCustomSegmentText, runCustomSegmentPreviewAnimation} from "./custom-segments.js";

$(document).ready(function () {
	/*
	COMMUNITY GRAPHICS
	 */

	// Community graphics main menu button
	$("#community-graphics").on('click', function () {
		if (globals.requestRunning) {
            return false;
        }
		playSoundEffect('success');
		hideMainMenuContent($());
		notie.hideAlerts();

		$('.community-graphics-search-container').hide();
		$('.community-graphics-search-results-container').hide();
		$(".community-graphics-input-name").val('');
		$(".community-graphics-input-age").val('');
		$('.community-graphics-search-menu-button').trigger('click');

		let el = $('#community-graphics-graphic');
		el.html('').show();
		resetCommunityGraphicsGraphic(el);

		$("#community-graphics-container").fadeIn('slow').removeClass('display-none');
		$(".community-graphics-input-name").focus();
	});

	// Community graphics search button
	$(".button-community-graphics-search").on('click', function () {
		let searchTerm = $('#community-graphics-container').find('.community-graphics-input-name').val();
		runTemplateSuperstarsSearch(searchTerm);
	});
	$(".community-graphics-input-name").on('keypress', function (e) {
		// Trigger search on enter key press
		if (e.which === 13 && $('.community-graphics-search-menu-button').hasClass('selected')) {
			$(".button-community-graphics-search").click();
		}
	});

	// Community graphics next/previous page buttons
	$('.community-graphics-next-page-button, .community-graphics-previous-page-button').on('click', function () {
		let page = $(this).data('page');
		let searchTerm = $('#community-graphics-container').find('.community-graphics-input-name').val();
		let sortValue = $('.sort-community-graphics-results-button.selected').text().trim().toLowerCase();
		runTemplateSuperstarsSearch(searchTerm, page, sortValue);
	});

	// Community graphics random button
	$(".button-community-graphics-random").on('click', function () {
		if (globals.requestRunning) {
			return false;
		}
		playSoundEffect('success');

		makeGetRequest('/_get_random_template_superstar', {},
			(data) => {
				// Get search results html
				let html = '';
				data.forEach(function (item) {
					html += getTemplateSuperstarHtml(item);
				});

				$('.community-graphics-search-results-number').text('Random result').show();
				$('.community-graphics-search-sort-buttons').show();

				// Select 'best' sort option for results
				$('.sort-community-graphics-results-button').removeClass('selected');
				$('.sort-community-graphics-results-button:contains("New")').addClass('selected');

				// Show results
				$('.community-graphics-search-results-container').html(html);
				$('.community-graphics-search-results-container').fadeIn();
				$('.community-graphics-search-container').show();

				// Put focus back on search field
				$(".community-graphics-input-name").focus();

				// Show graphic for first result
				$('.community-graphics-search-results-container').find('.community-graphics-search-result-item').trigger('click');
			});
	});

	// Community graphics sort results button
	$('#community-graphics-container').on('click', '.sort-community-graphics-results-button', function () {
		if (!$(this).hasClass('selected')) {
			$('.sort-community-graphics-results-button').removeClass('selected');
			$(this).addClass('selected');
		}
		let sortValue = $(this).text().trim().toLowerCase();
		let searchTerm = $('#community-graphics-container').find('.community-graphics-input-name').val();
		runTemplateSuperstarsSearch(searchTerm, null, sortValue);
	});

	// Load graphic upon clicking on search result
	$('#community-graphics-container').on('click', '.community-graphics-search-result-item', function () {
		if ($(this).hasClass('disabled')) {
			return false;
		}

		$('.community-graphics-search-result-item.selected').removeClass('selected');
		$(this).addClass('selected');
		let graphicCode = $(this).attr('data-graphic');
		$('.community-graphics-graphic-container').find('.load-character-code-input').val(graphicCode);
		$('.community-graphics-graphic-container').find('.load-character-code-button').trigger('click');
	});

	// Community graphics create button
	$(".button-community-graphics-create").on('click', function () {
		if (globals.requestRunning) {
			return false;
		}

		// Get graphic code
		let graphicCode = getCommunityGraphicsCode();

		// Get inputs
		let superstarName = $('#community-graphics-container').find('.community-graphics-input-name').val();
		let superstarAge = $('#community-graphics-container').find('.community-graphics-input-age').val();

		// Validate inputs
		if (superstarName.length <= 0) {
			notie.alert({type: 3, text: "Enter the Superstar's name"});
			return false;
		}
		if (superstarAge.length <= 0 || superstarAge < 10 || superstarAge > 100) {
			notie.alert({type: 3, text: "Enter the Superstar's age (between 10-100)"});
			return false;
		}

		makeGetRequest('/_add_template_superstar', {name: superstarName, age: superstarAge, graphic: graphicCode},
			(data) => {
				if (!data['error']) {
					playSoundEffect('success');
					let superstarTemplate = data['new_template_superstar'];
					notie.alert({
						type: 4, text: 'Superstar graphic added for {0} ({1} y/o)'.format(superstarTemplate['name'],
							superstarTemplate['age'])
					});
					$(".community-graphics-input-name").val('');
					$(".community-graphics-input-age").val('');
				} else {
					playSoundEffect('error');
					let superstarTemplate = data['existing_template_superstar'];
					if (data['error'] === 'already-exists') {
						notie.alert({
							type: 3,
							text: 'That superstar graphic already exists as {0} ({1} y/o)'.format(superstarTemplate['name'],
								superstarTemplate['age'])
						});
					}
				}
			});
	});
	$(".community-graphics-input-age").on('keypress', function (e) {
		// Trigger create on enter key press
		if (e.which === 13) {
			$(".button-community-graphics-create").click();
		}
	});

	// Community graphics menu buttons
	$('#community-graphics-container').on('click', '.community-graphics-create-menu-button', function () {
		playSoundEffect('success');
		$('.community-graphics-menu-button').removeClass('selected');
		$(this).addClass('selected');
		$("#community-graphics-container").find('.character-creator-controls').removeClass('display-none').addClass('display-inline-block');
		$("#community-graphics-container").find('.button-community-graphics-create').show();
		$("#community-graphics-container").find('.button-community-graphics-search').hide();
		$("#community-graphics-container").find('.button-community-graphics-random').hide();
		$('.community-graphics-search-container').hide();
		$('.community-graphics-search-results-container').hide();
		$('.community-graphics-input-age').show();
		$(".community-graphics-input-name").show();
		$('.community-graphics-best-and-new-container').hide();
		$('.community-graphics-my-graphics-container').hide();
		$('.community-graphics-pagination-buttons').hide();
	});
	$('#community-graphics-container').on('click', '.community-graphics-search-menu-button', function () {
		playSoundEffect('success');
		$('.community-graphics-menu-button').removeClass('selected');
		$(this).addClass('selected');
		$("#community-graphics-container").find('.character-creator-controls').addClass('display-none').removeClass('display-inline-block');
		$("#community-graphics-container").find('.button-community-graphics-create').hide();
		$("#community-graphics-container").find('.button-community-graphics-search').show();
		$("#community-graphics-container").find('.button-community-graphics-random').show();
		$('.community-graphics-input-age').hide();
		$('.community-graphics-search-container').hide();
		$('.community-graphics-search-results-container').hide();
		// Put focus on name field
		$(".community-graphics-input-name").show();
		$(".community-graphics-input-name").focus();
		$('.community-graphics-best-and-new-container').hide();
		$('.community-graphics-search-results-container').hide();
		$('.community-graphics-my-graphics-container').hide();
		$('.community-graphics-pagination-buttons').hide();
	});
	$('#community-graphics-container').on('click', '.community-graphics-best-new-menu-button', function () {
		if (globals.requestRunning) {
			return false;
		}
		playSoundEffect('success');

		// Get new and best graphics
		$('.community-graphics-menu-button').removeClass('selected');
		$(this).addClass('selected');
		$('.community-graphics-pagination-buttons').hide();

		makeGetRequest('/_get_template_superstars_new_and_best', {},
			(data) => {
				let newHtml = '';
				data['new'].forEach(function (item) {
					newHtml += getTemplateSuperstarHtml(item);
				});

				let bestHtml = '';
				data['best'].forEach(function (item) {
					bestHtml += getTemplateSuperstarHtml(item);
				});

				let recentlyRecommendedHtml = '';
				data['recently_recommended'].forEach(function (item) {
					recentlyRecommendedHtml += getTemplateSuperstarHtml(item);
				});

				$('.community-graphics-new-container').html(newHtml);
				$('.community-graphics-best-container').html(bestHtml);
				$('.community-graphics-recently-recommended-container').html(recentlyRecommendedHtml);
				$('.community-graphics-best-and-new-container').show();

				$('.community-graphics-best-container').scrollTop(0);
				$('.community-graphics-new-container').scrollTop(0);
				$('.community-graphics-recently-recommended-container').scrollTop(0);

				$("#community-graphics-container").find('.character-creator-controls').addClass('display-none').removeClass('display-inline-block');
				$("#community-graphics-container").find('.button-community-graphics-create').hide();
				$("#community-graphics-container").find('.button-community-graphics-search').hide();
				$("#community-graphics-container").find('.button-community-graphics-random').hide();
				$('.community-graphics-input-age').hide();
				$(".community-graphics-input-name").hide();
				$('.community-graphics-search-container').hide();
				$('.community-graphics-search-results-container').hide();
				$('.community-graphics-my-graphics-container').hide();
			});
	});
	$('#community-graphics-container').on('click', '.community-graphics-my-graphics-menu-button', function () {
		getTemplateSuperstarsForUser();
	});

	// Next/previous page of favorites buttons
	$('.my-favorites-next-page-button, .my-favorites-previous-page-button').on('click', function () {
		let page = $(this).data('page');
		getTemplateSuperstarsForUser(page, 'ratings');
	});
	$('.my-graphics-next-page-button, .my-graphics-previous-page-button').on('click', function () {
		let page = $(this).data('page');
		getTemplateSuperstarsForUser(page, 'graphics');
	});

	// Copy graphic
	$('#community-graphics-container').on('click', '.community-graphics-copy-graphic', function () {
		playSoundEffect('success');
		let graphicCode = getCommunityGraphicsCode();
		copyToClipboard(null, graphicCode);
	});

	// Community graphics recommend graphic
	$('#community-graphics-container').on('click', '.recommend-community-graphic-button', function (e) {
		e.stopPropagation();
		let el = $(this);
		let uid = $(this).closest('.community-graphics-search-result-item').attr('data-uid');
		rateTemplateSuperstarRequest(el, uid);
	});

	// Delete graphic
	$('#community-graphics-container').on('click', '.delete-community-graphic-button', function (e) {
		e.stopPropagation();
		let el = $(this).closest('.community-graphics-search-result-item');
		let uid = el.attr('data-uid');

		notie.confirm({
			text: 'Are you sure you want to delete this graphic?',
			submitText: 'Yes',
			cancelText: 'No',
			submitCallback: function () {
				deleteTemplateSuperstar(uid, el);
			}
		});
	});

	/*
	COMMUNITY SEGMENTS
	 */

	// Community segments main menu button
	$("#community-segments").on('click', function () {
		if (globals.requestRunning) {
            return false;
        }
		playSoundEffect('success');
		hideMainMenuContent($());
		notie.hideAlerts();

		$("#community-segments-container").fadeIn('slow');
		$("#community-segments-container").find('.community-segments-menu-button[data-value="browse"]').trigger('click');
	});

	// Community segments sort button
	$('.community-segments-sort-button').on('click', function () {
		let val = $(this).data('value');

		// Select this button
		$('.community-segments-sort-button').removeClass('selected');
		$(this).addClass('selected');

		if (val === 'search') {
			let searchTerm = $(this).siblings('.community-segments-search-input').val();
			// Validate
			if (searchTerm.length <= 0) {
				notie.alert({type: 3, text: "Enter a name to search for"});
				// Put focus back on search field
				$(this).siblings(".community-segments-search-input").focus();
				return false;
			}
			runTemplateSegmentItemsSearch(searchTerm);
		} else {
			getTemplateSegmentItems(val);
		}
	});
	$(".community-segments-search-input").on('keypress', function (e) {
		// Trigger search on enter key press
		if (e.which === 13) {
			$(e.target).siblings(".community-segments-search-button").trigger('click');
		}
	});

	// Community segments next/previous page buttons
	$('.community-segments-next-page-button, .community-segments-previous-page-button').on('click', function () {
		playSoundEffect('success');
		let page = $(this).data('page');
		let parent = $(this).closest('.community-segments-box');
		let val = parent.find('.community-segments-sort-button.selected').data('value');
		if (val === 'search') {
			let searchTerm = parent.find('.community-segments-search-input').val();
			runTemplateSegmentItemsSearch(searchTerm, page);
		} else {
			getTemplateSegmentItems(val, page);
		}
	});

	// Community segments recommend button
	$('#community-segments-container, .add-custom-segment-community-segments-container').on('click',
		'.recommend-community-segment-button', function (e) {
			e.stopPropagation();
			if (globals.requestRunning) {
				return false;
			}

			let uid = $(this).closest('.community-segments-search-result-item').attr('data-uid');
			let $this = $(this);

			makeGetRequest('/_rate_template_segment_item', {uid: uid},
				(data) => {
					if (!data['error']) {
						playSoundEffect('success');

						$this.siblings('.community-segments-item-recommendations').text(data['rating']);
						if (data['rated_positive']) {
							$this.removeClass('not-rated').addClass('rated')
						} else {
							$this.removeClass('rated').addClass('not-rated')
						}
					} else if (data['error'] === 'not-signed-in') {
						playSoundEffect('error');
						notie.alert({
							type: 4, text: 'You need to be logged in to favorite segments',
							stay: true
						});
					}
				});
		});

	// Community segments delete segment
	$('#community-segments-container').on('click', '.delete-community-segment-button', function (e) {
		e.stopPropagation();
		let el = $(this).closest('.community-segments-search-result-item');
		let uid = el.attr('data-uid');

		notie.confirm({
			text: 'Are you sure you want to delete this segment?',
			submitText: 'Yes',
			cancelText: 'No',
			submitCallback: function () {
				deleteTemplateSegmentItem(uid, el);
			}
		});
	});

	// Community segments menu button
	$('#community-segments-container').on('click', '.community-segments-menu-button', function () {
		playSoundEffect('success');
		let val = $(this).data('value');
		let parent = $(this).closest('.community-segments-box');

		if (val === 'copy') {
			let selected = parent.find('.community-segments-search-result-item.selected');
			if (selected.length > 0) {
				let uid = selected.data('uid');
				copyToClipboard(null, uid, 'Copied to clipboard. Paste ' +
					'into Import Segment when creating a segment in-game (JoW Paid).');
			} else {
				// Don't copy if no segment selected
				notie.alert({type: 4, text: "No segment selected. Select a segment to copy it."});
			}
			return false;
		}

		// Select this button
		$('.community-segments-menu-button').removeClass('selected');
		$(this).addClass('selected');

		if (val === 'browse') {
			$('.community-segments-browse').show();
			$('.community-segments-my-segments').hide();
			parent.find('.community-segments-sort-button[data-value="new"]').trigger('click');
		} else if (val === 'my-segments') {
			$('.community-segments-browse').hide();
			$('.community-segments-my-segments').show();
			parent.find('.community-segments-sort-button[data-value="user-segments"]').trigger('click');
		}
	});

	// Community segments select segment
	$('#community-segments-container').on('click', '.community-segments-search-result-item', function () {
		let parent = $(this).closest('.community-segments-box');
		if ($(this).hasClass('disabled')) {
			parent.find('.community-segments-preview-name').text('');
			parent.find('.community-segments-preview-start-text').text('No segment selected');
			parent.find('.community-segments-preview-action-text').text('');
			return false;
		}

		// Select this element
		parent.find('.community-segments-search-result-item.selected').removeClass('selected');
		$(this).addClass('selected');

		// Run preview
		parent.find('.community-segments-preview-singles-button').trigger('click');
	});

	// Community segments preview button
	$('#community-segments-container').on('click', '.community-segments-preview-singles-button, ' +
		'.community-segments-preview-tag-button', function () {
		let parent = $(this).closest('.community-segments-box');

		// Select this button
		$('.community-segments-preview-buttons-container .button').removeClass('selected');
		$(this).addClass('selected');

		// Get attributes
		let selected = parent.find('.community-segments-search-result-item.selected');
		if (selected.length <= 0) {
			// Don't run if no segment selected
			notie.alert({type: 4, text: "No segment selected. Select a segment to preview it."});
			return false;
		}
		let text = selected.data('text');
		let name = selected.data('name');
		let startText = getRandomChoice(text['start']);
		let actionText = getRandomChoice(text['action']);
		let numberOfParticipants = selected.data('participants');
		let chooseWinner = selected.data('choose-winner');

		// Get participants and type
		let dataType;
		let participants;
		if ($(this).hasClass('community-segments-preview-tag-button')) {
			dataType = 'tag';
			participants = previewSegmentTagParticipants;
		} else {
			dataType = 'singles';
			participants = previewSegmentSinglesParticipants;
		}

		// Get tag texts if present
		if (dataType === 'tag') {
			if (text['start_tag']) {
				startText = getRandomChoice(text['start_tag']);
			}
			if (text['action_tag']) {
				actionText = getRandomChoice(text['action_tag']);
			}
		}

		name = escapeHTML(name);
		startText = escapeHTML(startText);
		actionText = escapeHTML(actionText);

		// Get random participant objects based on number of participants
		shuffle(participants);
		participants = participants.slice(0, numberOfParticipants);

		let nameElement = parent.find('.community-segments-preview-name');
		let startTextElement = parent.find('.community-segments-preview-start-text');
		let actionTextElement = parent.find('.community-segments-preview-action-text');
		runCustomSegmentPreviewAnimation(name, startText, actionText, participants, chooseWinner, nameElement,
			startTextElement, actionTextElement);

		// Select winner
		parent.find('.community-segments-preview-container').off('click', '.match-wrestler');
		parent.find('.community-segments-preview-container').on('click', '.match-wrestler', function () {
			let name = $(this).text();

			// Put winner first in participants
			participants.sort(function (x, y) {
				return x.name === name ? -1 : y.name === name ? 1 : 0;
			});

			// Show action text
			actionText = parseCustomSegmentText(actionText, participants);
			actionTextElement.html(actionText).hide().fadeIn(500);
		});
	});
});

/*
Community Graphics
 */

function runTemplateSuperstarsSearch(searchTerm, page, sort) {
	if (globals.requestRunning) {
		return false;
	}
	playSoundEffect('success');

	makeGetRequest('/_get_template_superstar', {name: searchTerm, page: page, sort: sort},
		(data) => {
			let templateSuperstars = data['template_superstars'];

			// Get search results html
			let html = '';
			templateSuperstars.forEach(function (item) {
				html += getTemplateSuperstarHtml(item);
			});

			// Show empty results if no superstars found
			if (templateSuperstars.length <= 0) {
				html = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">' +
					'No Superstars found' +
					'</div>';
			}

			// Show next/prev page buttons
			showCommunityGraphicsPagination(data);

			// Show number of results found. Max results is 50.
			let resultsFound = data['total_results'];
			let resultsWord = 'results';
			if (templateSuperstars.length === 1) {
				resultsWord = 'result'
			}
			$('.community-graphics-search-results-number').text(resultsFound + ' ' + resultsWord + ' found').show();
			$('.community-graphics-search-sort-buttons').show();

			// Select 'best' sort option for results
			$('.sort-community-graphics-results-button').removeClass('selected');
			$('.sort-community-graphics-results-button:contains("' + toTitleCase(data['sort_value']) + '")')
				.addClass('selected');

			// Show results
			$('.community-graphics-search-results-container').html(html);
			$('.community-graphics-search-results-container').scrollTop(0);
			$('.community-graphics-search-results-container').fadeIn();
			$('.community-graphics-search-container').show();

			// Put focus back on search field
			$(".community-graphics-input-name").focus();
		});
}

function runTemplateSuperstarsEditorSearch(parent, searchTerm, page, sort) {
    if (globals.requestRunning) {
		return false;
	}
	playSoundEffect('success');

	makeGetRequest('/_get_template_superstar', {name: searchTerm, page: page, sort: sort},
		(data) => {
			// Get search results html
			let html = '';
			data['template_superstars'].forEach(function (item) {
				html += getTemplateSuperstarHtml(item, 'graphics-search-result-item');
			});

			// Show empty results if no superstars found
			if (data['template_superstars'].length <= 0) {
				html = '<div class="inner-box-item graphics-search-result-item disabled medium-dark-grey">' +
					'No Superstars found' +
					'</div>';
			}

			// Show next/prev page buttons
			showGraphicsPagination(data);

			// Show number of results found. Max results is 50.
			let resultsFound = data['total_results'];
			let resultsWord = 'results';
			if (data['template_superstars'].length === 1) {
				resultsWord = 'result'
			}
			parent.find('.graphics-search-results-number').text(resultsFound + ' ' + resultsWord + ' found').show();
			parent.find('.graphics-search-sort-buttons').show();

			// Select sort option for results
			parent.find('.graphics-search-sort-results-button').removeClass('selected');
			parent.find('.graphics-search-sort-results-button:contains("' +
				toTitleCase(data['sort_value']) + '")').addClass('selected');

			// Show results
			let searchResultsContainer = parent.find('.graphics-search-results-container')
			searchResultsContainer.html(html);
			searchResultsContainer.scrollTop(0);
			searchResultsContainer.fadeIn();
			parent.find('.graphics-search-results').show();

			// Put focus back on search field
			parent.find(".graphics-search-input-name").focus();
		});
}

function getTemplateSuperstarHtml(item, itemClass, belongsToUser) {
	if (typeof (itemClass) === 'undefined') itemClass = 'community-graphics-search-result-item';
	let graphicJSON = JSON.stringify(item['graphic']);
	let name = getShortenedName(escapeHTML(item['name']), 30);
	let creatorName = (item['creator_name']) ? '<span class="high-light-grey margin-left-7">by {0}</span>'.format(escapeHTML(item['creator_name'])) : '';

	let ratedClass = ' not-rated';
	if (item['rated_positive']) {
		ratedClass = ' rated'
	}
	let recommendations =
		'<i class="fa fa-star icon-button recommend-community-graphic-button' + ratedClass + '"></i>' +
		'<span class="community-graphics-item-recommendations medium-grey">' +
		item['positive_recommendations'] + '</span>';
	let deleteButton = '';
	if (belongsToUser) {
		deleteButton = '<i class="fa fa-times-circle-o ' +
			'delete-community-graphic-button icon-button light help-text" title="Delete"></i>';
	}

	return '<div class="inner-box-item ' + itemClass + '" data-graphic=\'' + graphicJSON + '\' ' +
		'data-uid="' + item['uid'] + '">' +
		'<div class="medium-dark-grey">' +
		'<div class="graphics-search-result-item-column-left line-height-1p6">' + name + creatorName + '</div>' +
		'<div class="graphics-search-result-item-column-right light-grey">' + item['age'] + ' y/o' + recommendations + deleteButton + '</div>' +
		'<div class="clear"></div>' +
		'</div>' +
		'</div>';
}

function showCommunityGraphicsPagination(data) {
    if (data['next_page']) {
        $('.community-graphics-next-page-button').removeClass('visibility-hidden').data('page', data['next_page'])
    } else {
        $('.community-graphics-next-page-button').addClass('visibility-hidden')
    }
    if (data['previous_page']) {
        $('.community-graphics-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_page'])
    } else {
        $('.community-graphics-previous-page-button').addClass('visibility-hidden')
    }

    if (data['next_page'] || data['previous_page']) {
        $('.community-graphics-pagination-buttons').show()
    }
    else {
        $('.community-graphics-pagination-buttons').hide()
    }
}

function showGraphicsPagination(data) {
    if (data['next_page']) {
        $('.graphics-next-page-button').removeClass('visibility-hidden').data('page', data['next_page'])
    } else {
        $('.graphics-next-page-button').addClass('visibility-hidden')
    }
    if (data['previous_page']) {
        $('.graphics-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_page'])
    } else {
        $('.graphics-previous-page-button').addClass('visibility-hidden')
    }

    if (data['next_page'] || data['previous_page']) {
        $('.graphics-pagination-buttons').show()
    }
    else {
        $('.graphics-pagination-buttons').hide()
    }
}

function getCommunityGraphicsCode() {
    // Get graphic code from share character button
    $('.community-graphics-graphic-container').find('.share-character').trigger('click').removeClass('selected');
    $('.community-graphics-graphic-container').find('.share-character-code-container').hide();
	return $('.community-graphics-graphic-container').find('.share-character-code-input').val();
}

function getTemplateSuperstarsForUser(page, selection) {
	if (globals.requestRunning) {
		return false;
	}
	playSoundEffect('success');

	$('.community-graphics-menu-button').removeClass('selected');
	$('.community-graphics-my-graphics-menu-button').addClass('selected');
	$('.community-graphics-pagination-buttons').hide();

	makeGetRequest('/_get_template_superstars_for_user', {page: page, selection: selection},
		(data) => {

			// My graphics (don't update if loading ratings page)
			if (selection !== 'ratings') {
				let myGraphicsHtml = '';
				data['my_graphics'].forEach(function (item) {
					myGraphicsHtml += getTemplateSuperstarHtml(item, 'community-graphics-search-result-item', true);
				});
				if (data['my_graphics'].length <= 0) {
					myGraphicsHtml = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">' +
						'No graphics added' +
						'</div>';
				}

				$('.community-graphics-my-graphics').html(myGraphicsHtml);
				$('.community-graphics-my-graphics').scrollTop(0);
				$('.community-graphics-my-graphics-container').show();

				if (data['next_graphics_page']) {
					$('.my-graphics-next-page-button').removeClass('visibility-hidden').data('page', data['next_graphics_page'])
				} else {
					$('.my-graphics-next-page-button').addClass('visibility-hidden')
				}
				if (data['previous_graphics_page']) {
					$('.my-graphics-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_graphics_page'])
				} else {
					$('.my-graphics-previous-page-button').addClass('visibility-hidden')
				}
			}

			// My favorites (don't update if loading graphics page)
			if (selection !== 'graphics') {
				let favoritesHtml = '';
				data['recommended'].forEach(function (item) {
					favoritesHtml += getTemplateSuperstarHtml(item);
				});
				if (data['recommended'].length <= 0) {
					favoritesHtml = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">' +
						'No graphics recommended' +
						'</div>';
				}

				$('.community-graphics-favorites').html(favoritesHtml);
				$('.community-graphics-favorites').scrollTop(0);

				if (data['next_ratings_page']) {
					$('.my-favorites-next-page-button').removeClass('visibility-hidden').data('page', data['next_ratings_page'])
				} else {
					$('.my-favorites-next-page-button').addClass('visibility-hidden')
				}
				if (data['previous_ratings_page']) {
					$('.my-favorites-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_ratings_page'])
				} else {
					$('.my-favorites-previous-page-button').addClass('visibility-hidden')
				}
			}

			$("#community-graphics-container").find('.character-creator-controls').addClass('display-none').removeClass('display-inline-block');
			$("#community-graphics-container").find('.button-community-graphics-create').hide();
			$("#community-graphics-container").find('.button-community-graphics-search').hide();
			$("#community-graphics-container").find('.button-community-graphics-random').hide();
			$('.community-graphics-input-age').hide();
			$(".community-graphics-input-name").hide();
			$('.community-graphics-search-container').hide();
			$('.community-graphics-search-results-container').hide();
			$('.community-graphics-best-and-new-container').hide();
		});
}

function deleteTemplateSuperstar(uid, el) {
	if (globals.requestRunning) {
		return false;
	}

	makeGetRequest('/_delete_template_superstar', {uid: uid},
		(data) => {
			if (!data['error']) {
				playSoundEffect('success');
				notie.alert({type: 4, text: "Graphic deleted", stay: true});
				el.remove();
			} else {
				playSoundEffect('error');
				if (data['error'] === 'not-found') {
					notie.alert({type: 3, text: 'That graphic could not be found. Please try again.'});
				}
				if (data['error'] === 'not-signed-in') {
					notie.alert({type: 3, text: 'You need to be logged in to delete graphics.'});
				}
				if (data['error'] === 'wrong-user') {
					notie.alert({type: 3, text: 'That graphic does not belong to you.'});
				}
			}
		});
}

/*
Community Segments
 */

function runTemplateSegmentItemsSearch(searchTerm, page) {
	if (globals.requestRunning) {
		return false;
	}
	playSoundEffect('success');

	makeGetRequest('/_get_template_segment_items', {name: searchTerm, sort: 'search', page: page},
		(data) => {
			// Get search results html
			let html = '';
			data['template_segment_items'].forEach(function (item) {
				html += getTemplateSegmentItemHtml(item);
			});

			// Show empty results if no segments found
			if (data['template_segment_items'].length <= 0) {
				html = '<div class="inner-box-item community-segments-search-result-item disabled medium-dark-grey">' +
					'No segments found' +
					'</div>';
			}

			// Show next/prev page buttons
			showCommunitySegmentsPagination(data);

			// Show number of segments found (if searching)
			let resultsFound = data['total_results'];
			let resultsWord = 'segments';
			if (resultsFound === 1) {
				resultsWord = 'segment'
			}
			$('.community-segments-results-number').text(resultsFound + ' ' + resultsWord + ' found').show();

			// Show results
			$('.community-segments-results-container').html(html).show();
			$('.community-segments-results-container').scrollTop(0);

			// Put focus back on search field
			$(".community-segments-search-input").focus();

			// Preview first result
			$('.community-segments-search-result-item').eq(0).trigger('click');
		});
}

function getTemplateSegmentItemHtml(item, belongsToUser) {
    let itemText = item['text'];
    let textJson = JSON.stringify(itemText).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    let name = getShortenedName(escapeHTML(item['name']), 30);
    let creatorName = (item['creator_name']) ? '<span class="high-light-grey margin-left-7">by {0}</span>'.format(escapeHTML(item['creator_name'])) : '';

    let ratedClass = ' not-rated';
    if (item['rated_positive']) {
        ratedClass = ' rated'
    }
    let recommendations =
        '<i class="fa fa-star icon-button recommend-community-segment-button' + ratedClass + '"></i>' +
        '<span class="community-segments-item-recommendations medium-grey">' + item['positive_recommendations'] + '</span>';
    let deleteButton = '';
    if (belongsToUser) {
        deleteButton = '<i class="fa fa-times-circle-o ' +
                            'delete-community-segment-button icon-button light help-text" title="Delete"></i>';
    }

	return '<div class="inner-box-item community-segments-search-result-item" ' +
	    'data-participants="' + item['max_participants'] + '"' +
	    ' data-name="' + item['name'].replace(/"/g, "&quot;").replace(/'/g, "&#39;") + '" ' +
	    ' data-choose-winner="' + item['choose_winner'] + '" ' +
	    'data-text="' + textJson + '" ' +
	    'data-uid="' + item['uid'] + '">' +
	    '<div class="medium-dark-grey">' +
	    '<div class="community-segments-search-result-item-column-left line-height-1p6">' + name + creatorName + '</div>' +
	    '<div class="community-segments-search-result-item-column-right light-grey">' + recommendations + deleteButton + '</div>' +
	    '<div class="clear"></div>' +
	    '</div>' +
	    '</div>';
}

function showCommunitySegmentsPagination(data) {
    if (data['next_page']) {
        $('.community-segments-next-page-button').removeClass('visibility-hidden').data('page', data['next_page'])
    } else {
        $('.community-segments-next-page-button').addClass('visibility-hidden')
    }
    if (data['previous_page']) {
        $('.community-segments-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_page'])
    } else {
        $('.community-segments-previous-page-button').addClass('visibility-hidden')
    }

    if (data['next_page'] || data['previous_page']) {
        $('.community-segments-pagination-buttons').show()
    }
    else {
        $('.community-segments-pagination-buttons').hide()
    }
}

function getTemplateSegmentItems(val, page) {
	if (globals.requestRunning) {
		return false;
	}
	playSoundEffect('success');

	makeGetRequest('/_get_template_segment_items', {sort: val, page: page},
		(data) => {
			// Get html
			let html = '';
			let belongsToUser = (val === 'user-segments');
			data['template_segment_items'].forEach(function (item) {
				html += getTemplateSegmentItemHtml(item, belongsToUser);
			});

			// Show empty results if no segments found
			if (data['template_segment_items'].length <= 0) {
				html += '<div class="inner-box-item community-segments-search-result-item disabled medium-dark-grey">' +
					'No segments found' +
					'</div>';
			}

			$('.community-segments-results-container').html(html).show();
			$('.community-segments-results-container').scrollTop(0);

			// Show next/prev page buttons
			showCommunitySegmentsPagination(data);

			// Hide search results number, my segments
			$('.community-segments-results-number').hide();
			$('.community-segments-my-segments-container').hide();

			// Reset search
			$(".community-segments-search-input").val('');

			// Preview first result
			$('.community-segments-search-result-item').eq(0).trigger('click');
		});
}

function deleteTemplateSegmentItem(uid, el) {
	if (globals.requestRunning) {
		return false;
	}

	makeGetRequest('/_delete_template_segment_item', {uid: uid},
		(data) => {
			if (!data['error']) {
				playSoundEffect('success');
				notie.alert({type: 4, text: "Segment deleted", stay: true});
				el.remove();
			} else {
				playSoundEffect('error');
				if (data['error'] === 'not-found') {
					notie.alert({type: 3, text: 'That segment could not be found. Please try again.'});
				}
				if (data['error'] === 'not-signed-in') {
					notie.alert({type: 3, text: 'You need to be logged in to delete segments.'});
				}
				if (data['error'] === 'wrong-user') {
					notie.alert({type: 3, text: 'That segment does not belong to you.'});
				}
			}
		});
}

function loadCommunitySegment(el, uid) {
	makeGetRequest('/_get_template_segment_item_from_uid', {uid: uid},
		(data) => {
			if (!data['error']) {
				playSoundEffect('success');
				notie.alert({type: 4, text: 'Segment loaded'});

				$(".add-custom-segment-template-button").removeClass('selected');

				// Reset
				customSegmentsData.addCustomSegmentChangesMade = false;

				// Reset texts
				$('.add-custom-segment-start-text').val('');
				$('.add-custom-segment-action-text').val('');
				$('.add-custom-segment-tag-start-text').val('');
				$('.add-custom-segment-tag-action-text').val('');

				// Add segment data
				$('.add-custom-segment-name-input').val(data['name']);
				$('.add-custom-segment-participants-input').val(data['max_participants']);

				// Remove extra action text inputs
				$('.add-custom-segment-action-text').not(':first').remove();
				$('.add-custom-segment-tag-action-text').not(':first').remove();

				let text = data['text'];
				$('.add-custom-segment-start-text').val(text['start']);
				$('.add-custom-segment-action-text').val(text['action'][0]);

				// Multiple action texts
				let actionTextHtml = '<textarea class="add-custom-segment-action-text' +
					' styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
				text['action'].forEach(function (actionText, i) {
					if (i > 0) {
						$('.add-custom-segment-action-text').last().after(actionTextHtml);
						$('.add-custom-segment-action-text').eq(i).val(actionText);
					}
				});

				if (text['start_tag']) {
					$('.add-custom-segment-tag-start-text').val(text['start_tag']);
				}
				if (text['action_tag']) {
					$('.add-custom-segment-tag-action-text').val(text['action_tag'][0]);

					// Multiple action texts
					let actionTextHtml = '<textarea class="add-custom-segment-tag-action-text' +
						' styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
					text['action_tag'].forEach(function (actionText, i) {
						if (i > 0) {
							$('.add-custom-segment-tag-action-text').last().after(actionTextHtml);
							$('.add-custom-segment-tag-action-text').eq(i).val(actionText);
						}
					});
				}

				let chooseWinnerValue = (data['choose_winner']) ? 'yes' : 'no';
				$('input[name="add-custom-segment-choose-winner-option"][value="' + chooseWinnerValue + '"]')
					.prop('checked', true);
				let feudOnlyValue = (data['feud_only']) ? 'yes' : 'no';
				$('input[name="add-custom-segment-feud-only-option"][value="' + feudOnlyValue + '"]')
					.prop('checked', true);
				let sillyValue = (data['silly']) ? 'yes' : 'no';
				$('input[name="add-custom-segment-silly-option"][value="' + sillyValue + '"]')
					.prop('checked', true);

				// Run preview
				$('.add-custom-segment-preview-singles-button').trigger('click');
			} else {
				playSoundEffect('error');
				if (data['error'] === 'not-found') {
					notie.alert({
						type: 3, text: 'That Segment could not be found. Please try again.'
					});
				}
			}
		});
}

function rateTemplateSuperstarRequest(el, uid) {
	if (globals.requestRunning) {
		return false;
	}

	makeGetRequest('/_rate_template_superstar', {uid: uid},
		(data) => {
			if (!data['error']) {
				playSoundEffect('success');

				el.siblings('.community-graphics-item-recommendations').text(data['rating']);
				if (data['rated_positive']) {
					el.removeClass('not-rated').addClass('rated')
				}
				else {
					el.removeClass('rated').addClass('not-rated')
				}
			}
			else if (data['error'] === 'not-signed-in') {
				playSoundEffect('error');
				notie.alert({
					type: 4, text: 'You need to be logged in to rate graphics',
					stay: true
				});
			}
		});
}

export {runTemplateSuperstarsEditorSearch, loadCommunitySegment, rateTemplateSuperstarRequest}